/* eslint-disable max-len */
import { scrollToElement } from '@common/utils/dom';

const formClass = 'form-flow';
const waitlistModalId = 'waitlist-modal';
const contentClass = 'nset-preparation-content';
const ctaClass = `${contentClass}__cta`;
const nsetPreparationButtonClass = 'nset-preparation-button';
const activeWaitlistMode = document.querySelector(`#${waitlistModalId} .${formClass}__mode--active`);

const parentFormEl = document.querySelector(`.${formClass}__modes`);
const contentEls = document.querySelectorAll(`.nset-preparation-button__submission`);
const ctaLoggedInUser = document.querySelectorAll(`.${ctaClass}--can-view`);
const ctaLogOutUser = document.querySelectorAll(`.${ctaClass}--cannot-view`);
const nsetPreparationButton = document.querySelectorAll(`.${nsetPreparationButtonClass}__cta--unlock-view`);

// method to show the content wherever required
function showContent() {
  ctaLogOutUser?.forEach(button => button.classList.add('hidden'));
  ctaLoggedInUser?.forEach(button => button.classList.remove('hidden'));
  nsetPreparationButton?.forEach(button => button.classList.add('hidden'));
}

function nsetPreparationSuccessFlow() {
  showContent();
  const sectionEl = document.querySelector('#nset-preparation');
  scrollToElement(sectionEl);
}

function initialize() {
  if (activeWaitlistMode && contentEls) {
    [...contentEls].forEach((contentEl) => {
      contentEl.addEventListener('click', () => {
        let successAction;
        if (contentEl.classList.contains(`${nsetPreparationButtonClass}-locked`)) {
          successAction = 'nset_preparation_video_button';
        } else {
          successAction = 'nset_preparation_video_thumbnail';
        }
        parentFormEl?.setAttribute('data-success-action', successAction);
      });
    });
  } else {
    showContent();
  }
}

export default {
  initialize,
  showContent,
  nsetPreparationSuccessFlow,
};
